/* 仅兼容历史产品校验使用的 jQuery.ajax 同步调用，避免加载第三方 jQuery CDN。 */
(function (window) {
  'use strict';
  if (window.jQuery) return;

  function encode(data) {
    return Object.keys(data || {}).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key] == null ? '' : data[key]);
    }).join('&');
  }

  window.jQuery = {
    ajax: function (options) {
      var request = new XMLHttpRequest();
      var method = (options.method || options.type || 'GET').toUpperCase();
      var body = method === 'GET' ? null : encode(options.data);
      var url = options.url;
      if (method === 'GET' && body) url += (url.indexOf('?') === -1 ? '?' : '&') + body;
      request.open(method, url, options.async !== false);
      if (body) request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      try {
        request.send(body);
      } catch (_error) {
        return { status: 0, responseJSON: null };
      }
      var response = null;
      try { response = request.responseText ? JSON.parse(request.responseText) : null; } catch (_error) {}
      return { status: request.status, responseJSON: response };
    }
  };
}(window));
